import { render, staticRenderFns } from "./VoiceSelector.vue?vue&type=template&id=d48a9020&scoped=true"
import script from "./VoiceSelector.vue?vue&type=script&lang=js"
export * from "./VoiceSelector.vue?vue&type=script&lang=js"
import style0 from "./VoiceSelector.vue?vue&type=style&index=0&id=d48a9020&prod&scoped=true&lang=scss"
import style1 from "./VoiceSelector.vue?vue&type=style&index=1&id=d48a9020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48a9020",
  null
  
)

export default component.exports